var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9414_15395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9414_15395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 34C22.75 34 21.5792 33.7625 20.4875 33.2875C19.3958 32.8125 18.4458 32.1708 17.6375 31.3625C16.8292 30.5542 16.1875 29.6042 15.7125 28.5125C15.2375 27.4208 15 26.25 15 25H17C17 26.95 17.6792 28.6042 19.0375 29.9625C20.3958 31.3208 22.05 32 24 32C25.95 32 27.6042 31.3208 28.9625 29.9625C30.3208 28.6042 31 26.95 31 25C31 23.05 30.3208 21.3958 28.9625 20.0375C27.6042 18.6792 25.95 18 24 18H23.85L25.4 19.55L24 21L20 17L24 13L25.4 14.45L23.85 16H24C25.25 16 26.4208 16.2375 27.5125 16.7125C28.6042 17.1875 29.5542 17.8292 30.3625 18.6375C31.1708 19.4458 31.8125 20.3958 32.2875 21.4875C32.7625 22.5792 33 23.75 33 25C33 26.25 32.7625 27.4208 32.2875 28.5125C31.8125 29.6042 31.1708 30.5542 30.3625 31.3625C29.5542 32.1708 28.6042 32.8125 27.5125 33.2875C26.4208 33.7625 25.25 34 24 34Z",
    fill: "#7F8FAF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.c4f867d5ff820579e7f15036f05dbb88.svg";
export { ForwardRef as ReactComponent };